import type { TTagOptionDto } from '@homepal/api-contract'

import { GlobalFilterVariant } from 'types/GlobalGlobalFilter'
import { postWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/tag-options`

export async function getAllTagOptions() {
  return postWithRedirect<TTagOptionDto[]>(URL, {
    data: { global_filter: { variant: GlobalFilterVariant.ALL } }
  })
}
